import script from "./kejianpingdingdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./kejianpingdingdetail.vue?vue&type=script&setup=true&lang=js"

import "./kejianpingdingdetail.vue?vue&type=style&index=0&id=9ab69d10&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ab69d10"]])

export default __exports__